import React, { useState, useEffect } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import { toast } from "react-toastify";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { apiRoutes } from "../../../../routes/api/apiRoutes";
import { useNavigate, useParams } from "react-router-dom";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";

const EditTestimonial = () => {
  const [response, loading, error, callAPI, statusCode] = useApiCallHooks();
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSet, setIsSet] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    job_role: "",
    description: "",
    status: "Active",
    company_logo: "",
    profile_pic: "",
    company_logo_url: "",
    profile_pic_url: "",
    _method: "PUT",
  });

  // Fetch existing testimonial
  useEffect(() => {
    callAPI("get","admin/testimonials" + "/" + id);
  }, []);

  useEffect(() => {
    if (response?.data && !isSet) {
      setFormData({
        ...formData,
        ...response.data,
        company_logo_url: response.data.company_logo,
        profile_pic_url: response.data.profile_pic,
      });
      setIsSet(true);
    }
  }, [response]);

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   const submitData = new FormData();
  //   Object.keys(formData).forEach((key) => {
  //     if (key === "company_logo" || key === "profile_pic") {
  //       if (formData[key] instanceof File) {
  //         submitData.append(key, formData[key]);
  //       }
  //     } else {
  //       submitData.append(key, formData[key]);
  //     }
  //   });

  //   callAPI("post","admin/testimonials" + "/" + id, formData);
  // };

const handleSubmit = (e) => {
  e.preventDefault();
  const submitData = new FormData();
  Object.keys(formData).forEach((key) => {
    if (key === "company_logo" || key === "profile_pic") {
      if (formData[key] instanceof File) {
        submitData.append(key, formData[key]);
      }
    } else {
      submitData.append(key, formData[key]);
    }
  });

  callAPI("post", "admin/testimonials" + "/" + id, submitData);
};


  useEffect(() => {
    if (statusCode === 202) {
      toast.success("Testimonial updated successfully!");
      setTimeout(() => navigate(uiRoutes.admin.testimonial.list), 1000);
    }
  }, [statusCode]);

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container">
          <PageHeading
            title="Edit Testimonial"
            subTitle="Update testimonial details below."
          />
          <div className="card p-4 shadow-sm mt-3">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* Name */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    value={formData.name}
                    className="form-control py-2"
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  />
                  <span className="val-message">
                    {error?.message === "ValidationError" && error?.data?.name}
                  </span>
                </div>

                {/* Job Role */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Job Role</label>
                  <input
                    type="text"
                    value={formData.job_role}
                    className="form-control py-2"
                    onChange={(e) => setFormData({ ...formData, job_role: e.target.value })}
                  />
                  <span className="val-message">
                    {error?.message === "ValidationError" && error?.data?.job_role}
                  </span>
                </div>

                {/* Description */}
                <div className="col-12 mb-3">
                  <label className="form-label">Description</label>
                  <textarea
                    rows={4}
                    className="form-control py-2"
                    value={formData.description}
                    onChange={(e) =>
                      setFormData({ ...formData, description: e.target.value })
                    }
                  />
                  <span className="val-message">
                    {error?.message === "ValidationError" && error?.data?.description}
                  </span>
                </div>

                {/* Status */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Status</label>
                  <select
                    className="form-select py-2"
                    value={formData.status}
                    onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                  <span className="val-message">
                    {error?.message === "ValidationError" && error?.data?.status}
                  </span>
                </div>

                {/* Company Logo */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Company Logo</label>
                  <input
                    type="file"
                    className="form-control py-2"
                    accept="image/*"
                    onChange={(e) =>
                      setFormData({ ...formData, company_logo: e.target.files[0] })
                    }
                  />
                  {formData.company_logo_url && (
                    <img
                      src={formData.company_logo_url}
                      alt="Company Logo"
                      height={100}
                      className="mt-2"
                    />
                  )}
                  <span className="val-message">
                    {error?.message === "ValidationError" && error?.data?.company_logo}
                  </span>
                </div>

                {/* Profile Picture */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Profile Picture</label>
                  <input
                    type="file"
                    className="form-control py-2"
                    accept="image/*"
                    onChange={(e) =>
                      setFormData({ ...formData, profile_pic: e.target.files[0] })
                    }
                  />
                  {formData.profile_pic_url && (
                    <img
                      src={formData.profile_pic_url}
                      alt="Profile Pic"
                      height={100}
                      className="mt-2"
                    />
                  )}
                  <span className="val-message">
                    {error?.message === "ValidationError" && error?.data?.profile_pic}
                  </span>
                </div>
              </div>

              <button type="submit" className="btn btn-primary mt-3">
                Update Testimonial
              </button>
            </form>
          </div>
        </div>
      }
    />
  );
};

export default EditTestimonial;
